<template>
  <div id="allocation-clinical-cases">
    <Title :title="tituloComponente" />
    <div class="form">
      <InputGroup>
        <InputWrapper>
          <el-input
            v-model="email"
            placeholder="E-mail"
            class="flexible-input"
            type="email"
            @blur="handleEmailBlur"
          />
        </InputWrapper>
        <InputWrapper>
          <el-input
            v-model="name"
            placeholder="Nome do médico"
            class="flexible-input"
            type="text"
            :disabled="nameDisabled"
            ref="nameInput"
          />
        </InputWrapper>
        <InputWrapper>
          <el-input
            v-model="phone"
            placeholder="Telefone"
            class="flexible-input"
            v-mask="['(##) ####-####', '(##) # ####-####']"
            type="text"
            :disabled="phoneDisabled"
          />
        </InputWrapper>
      </InputGroup>
      <InputGroup>
        <InputWrapper>
          <el-input
            v-model="quantity"
            placeholder="Quantidade de casos clínicos"
            class="flexible-input"
            type="number"
            min="0"
            ref="quantityInput"
          />
        </InputWrapper>
        <InputWrapper>
          <el-select
            v-model="contract"
            placeholder="Casos Clínicos"
            no-match-text="Nenhuma caso clínico encontrado"
            filterable
            size="large"
            clearable
          >
            <el-option
              v-for="item in getContracts"
              :key="item?.contractId"
              :label="item?.contractName"
              :value="item?.contractId"
            />
          </el-select>
        </InputWrapper>
      </InputGroup>
      <div class="save">
        <el-button
          type="primary"
          @click="handleSave"
          :disabled="isSaveDisabled"
        >
          Salvar
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from 'vue-toastification'
import { mapActions, mapGetters } from 'vuex'

import InputGroup from '@/components/inputGroup'
import InputWrapper from '@/components/inputWrapper'
import Title from '@/components/title'

export default {
  name: 'AllocationClinicalCasesForm',
  components: {
    InputWrapper,
    InputGroup,
    Title
  },
  setup() {
    const toast = useToast()
    return { toast }
  },
  data() {
    return {
      tituloComponente: 'Dados Cadastrais',
      name: null,
      quantity: null,
      email: null,
      contract: null,
      nameDisabled: false,
      phoneDisabled: false,
      phone: null,
      submitted: false
    }
  },
  computed: {
    ...mapGetters('consultationClinicalCases', ['getContracts']),
    isSaveDisabled() {
      return (
        !this.name ||
        !this.email ||
        !this.quantity ||
        !this.phone ||
        !this.contract
      )
    }
  },
  async mounted() {
    await this.getUser()
    const industryId = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user')).industryId
      : null

    await this.setIndustryId(industryId)
    await this.fetchContracts()
  },
  methods: {
    ...mapActions('user', ['getUser', 'findUserByEmail']),
    ...mapActions('allocationClinicalCases', ['addClientDoctor']),
    ...mapActions('consultationClinicalCases', [
      'fetchContracts',
      'setIndustryId'
    ]),
    async handleSave() {
      this.submitted = true
      if (this.isSaveDisabled) {
        return
      }

      const userData = {
        doctorName: this.name,
        doctorEmail: this.email,
        doctorPhone: this.phone,
        numberOfClinicalCases: Number(this.quantity),
        contractId: this.contract
      }

      await this.addClientDoctor(userData)
      this.clearForm()
    },
    clearForm() {
      this.name = null
      this.email = null
      this.quantity = null
      this.contract = null
      this.phone = null
      this.submitted = false
      this.phoneDisabled = false
      this.nameDisabled = false
    },
    async handleEmailBlur() {
      await this.findUser()
      await this.findUser2()
    },
    async findUser() {
      if (this.email && this.email.length > 6) {
        const user = await this.findUserByEmail({
          email: this.email,
          userType: 'client_doctor'
        })
        if (user) {
          this.name = user.name
          this.phone = user.phone
          this.nameDisabled = true
          this.phoneDisabled = true
          this.$nextTick(() => {
            this.$refs.quantityInput.focus()
          })
        } else {
          this.phone = ''
          this.name = ''
          this.nameDisabled = false
          this.phoneDisabled = false
        }
      }
    },

    async findUser2() {
      if (this.email && this.email.length > 6) {
        const user = await this.findUserByEmail({
          email: this.email,
          userType: 'consultant_doctor'
        })
        if (user) {
          this.toast.warning(
            'E-mail já cadastrado para médico consultor, por favor utilizar outro e-mail'
          )
          this.clearForm()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/index.scss';

.error {
  color: red;
  font-size: 0.9em;
}
</style>
